import { render, staticRenderFns } from "./NsProductDetail.vue?vue&type=template&id=20ac123b&"
import script from "./NsProductDetail.vue?vue&type=script&lang=js&"
export * from "./NsProductDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20ac123b')) {
      api.createRecord('20ac123b', component.options)
    } else {
      api.reload('20ac123b', component.options)
    }
    module.hot.accept("./NsProductDetail.vue?vue&type=template&id=20ac123b&", function () {
      api.rerender('20ac123b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/product-components/components/NsProductDetail.vue"
export default component.exports